import { Link } from "react-router-dom";
import { Card, CardBody, Col } from "reactstrap";
import { H6, Image, LI, P, UL } from "../../../../../AbstractElements";
import { Comments, Href } from "../../../../../Constants/Constants";
import { BlogCommentsData } from "../../../../../Data/Miscellaneous/Blog";
import { dynamicImage } from "../../../../../Utils";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const BlogComments = () => {
  return (
    <Col sm="12">
      <Card className="blog-comment">
        <CommonCardHeader title={Comments} headClass="pb-0 border-0" />
        <CardBody>
          <UL className="comment-section simple-list">
            {BlogCommentsData.map((item, index) => (
              <LI className={item.replyClass} key={index}>
                <div className="d-flex">
                  <Image src={dynamicImage(item.avatar)} alt="Generic placeholder image" />
                  <div className="flex-grow-1">
                    <H6>{item.name}</H6>
                    <span>( {item.date} )<Link className="ms-1" to={Href}>reply</Link></span>
                    <P>{item.content}</P>
                  </div>
                </div>
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BlogComments;
